/* eslint-env browser */
'use strict';

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var publicIp = require('public-ip');

var isOnline = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(options) {
    var publicIpFunctionName;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _objectSpread({
              timeout: 5000,
              ipVersion: 4
            }, options);

            if (!(navigator && navigator.onLine === false)) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", false);

          case 3:
            publicIpFunctionName = options.ipVersion === 4 ? 'v4' : 'v6';
            _context.prev = 4;
            _context.next = 7;
            return publicIp[publicIpFunctionName](options);

          case 7:
            return _context.abrupt("return", true);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](4);
            return _context.abrupt("return", false);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 10]]);
  }));

  return function isOnline(_x) {
    return _ref.apply(this, arguments);
  };
}();

module.exports = isOnline;